// extracted by mini-css-extract-plugin
export default {"screen-titles--title":"TimeClock_screen-titles--title__CE4tT","timeclock":"TimeClock_timeclock__utI36"};